import { useState } from 'react';
import { CTAModal } from './CTAModal';

export function ClosingSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<'trial' | 'contact' | 'line'>('trial');

  const openModal = (type: 'trial' | 'contact' | 'line') => {
    setModalType(type);
    setIsModalOpen(true);
  };

  const ctas = [
    { text: '今すぐ無料体験を申し込む', type: 'trial' as const, icon: 'ri-calendar-check-line', color: 'bg-orange-500 hover:bg-orange-600' },
    { text: 'まずは気軽に相談してみる', type: 'contact' as const, icon: 'ri-mail-line', color: 'bg-blue-500 hover:bg-blue-600' },
    { text: 'LINEで簡単に質問する', type: 'line' as const, icon: 'ri-chat-3-line', color: 'bg-green-500 hover:bg-green-600' },
    { text: '無料体験で変化を実感する', type: 'trial' as const, icon: 'ri-emotion-happy-line', color: 'bg-orange-500 hover:bg-orange-600' },
    { text: '成績アップの第一歩を踏み出す', type: 'trial' as const, icon: 'ri-rocket-line', color: 'bg-blue-500 hover:bg-blue-600' },
    { text: 'お子様の未来のために相談する', type: 'contact' as const, icon: 'ri-parent-line', color: 'bg-purple-500 hover:bg-purple-600' },
    { text: '定期テスト対策を始める', type: 'trial' as const, icon: 'ri-file-list-3-line', color: 'bg-orange-500 hover:bg-orange-600' },
    { text: '学習習慣づけをサポートしてもらう', type: 'contact' as const, icon: 'ri-calendar-check-line', color: 'bg-blue-500 hover:bg-blue-600' },
    { text: '苦手克服の方法を聞いてみる', type: 'line' as const, icon: 'ri-question-answer-line', color: 'bg-green-500 hover:bg-green-600' },
    { text: '内申点アップを目指して始める', type: 'trial' as const, icon: 'ri-star-line', color: 'bg-orange-500 hover:bg-orange-600' }
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl shadow-2xl p-8 md:p-12 text-center text-white mb-12">
          <h2 className="text-3xl md:text-4xl font-black mb-6 leading-tight">
            中1・中2の積み上げが<br className="md:hidden" />高校受験を決める
          </h2>
          
          <div className="space-y-4 mb-8">
            <p className="text-base md:text-lg leading-relaxed">
              <strong>今から始めれば差がつく</strong><br />
              中学1年生・中学2年生の学習内容は、高校受験の基礎となります。
            </p>
            
            <p className="text-base md:text-lg leading-relaxed">
              <strong>定期テスト対策</strong>で点数を上げ、<strong>提出物管理</strong>で内申点を守り、<br className="hidden md:block" />
              <strong>学習習慣</strong>を身につけることが、合格への近道です。
            </p>
            
            <p className="text-base md:text-lg leading-relaxed">
              廿日市市の<strong>個別指導</strong>で、一人ひとりに合わせた<strong>勉強のやり方</strong>を伝授。<br className="hidden md:block" />
              <strong>苦手克服</strong>から<strong>成績アップ</strong>まで、しっかりサポートします。
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-8">
            <p className="text-xl md:text-2xl font-bold mb-2">
              まずは無料体験でOK
            </p>
            <p className="text-sm md:text-base">
              お子様に合うかどうか、実際の授業を体験してからご判断ください
            </p>
          </div>
        </div>

        <div className="text-center mb-8">
          <h3 className="text-2xl md:text-3xl font-black text-gray-800 mb-4">
            今すぐ行動を起こしましょう
          </h3>
          <p className="text-sm md:text-base text-gray-600">
            お子様の未来のために、今日から始めませんか？
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {ctas.map((cta, index) => (
            cta.type === 'line' ? (
              <a
                key={index}
                href="https://lin.ee/Od9tigSF"
                target="_blank"
                rel="noopener noreferrer"
                className={`${cta.color} text-white font-bold text-base px-6 py-4 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap text-center`}
              >
                <i className={`${cta.icon} mr-2`}></i>
                {cta.text}
              </a>
            ) : (
              <button
                key={index}
                onClick={() => openModal(cta.type)}
                className={`${cta.color} text-white font-bold text-base px-6 py-4 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap`}
              >
                <i className={`${cta.icon} mr-2`}></i>
                {cta.text}
              </button>
            )
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-orange-50 border-2 border-orange-200 rounded-2xl p-6 md:p-8">
            <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-4">
              <div className="flex items-center gap-2 text-gray-800">
                <i className="ri-phone-line text-3xl text-orange-600"></i>
                <div className="text-left">
                  <p className="text-sm text-gray-600">お電話でのお問い合わせ</p>
                  <p className="text-2xl font-black">0829-78-1638</p>
                </div>
              </div>
              <div className="hidden md:block w-px h-12 bg-orange-300"></div>
              <div className="text-gray-700">
                <p className="text-sm">平日 16:00-21:00</p>
                <p className="text-sm">土日 14:00-21:00</p>
              </div>
            </div>
            <p className="text-sm text-gray-600">
              廿日市市大野の学習塾NICK | 中学生の定期テスト対策・学習習慣づけ
            </p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://29-jyuku.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold text-base px-8 py-4 rounded-full shadow transition-all duration-300 hover:shadow-md cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line text-lg"></i>
            もっと詳しく見たい人はこちら
          </a>
        </div>
      </div>

      <CTAModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        type={modalType}
      />
    </section>
  );
}
